import { clientFetch } from "@/lib/api/client-fetch";
import type { Workspace } from "@/lib/supabase";

export type WorkspacesPayload = {
  workspaces: Workspace[];
  active_workspace_id: string | null;
};

export async function fetchWorkspaces(): Promise<WorkspacesPayload> {
  const res = await clientFetch("/api/workspaces");
  if (!res.ok) throw new Error("Failed to fetch workspaces");
  const payload = await res.json();
  return payload.data as WorkspacesPayload;
}
